import { Checkbox } from 'antd';
import { useState } from 'react';

const GenderSelector = (props) => {

    const CheckboxGroup = Checkbox.Group;
    const options = [
      { label: 'รวมทั้งสองเพศ', value: 'รวม' },
      { label: 'เพศชาย', value: 'ชาย' },
      { label: 'เพศหญิง', value: 'หญิง' }
    ];
    const defaultCheckedList = ['ชาย'];
    
    const [checkedList, setCheckedList] = useState(defaultCheckedList);

    const onChange = list => {
      setCheckedList(list);
    };
    
    props.onChange(checkedList);

    return ( 
        <div>
          <CheckboxGroup options={options} value={checkedList} onChange={onChange}>
                <Checkbox value="รวม">รวมทั้งสองเพศ</Checkbox>
                <Checkbox value="ชาย">เพศชาย</Checkbox>
                <Checkbox value="หญิง">เพศหญิง</Checkbox>
          </CheckboxGroup>
        </div>
      
     );
}
 
export default GenderSelector;